import styles from './index.module.scss';
import { utility } from '@phi/components';
import { defineComponent, h } from 'vue';
import xclose from './xclose.inline.svg';

export default defineComponent({
    props: {
        label: {
            required: true,
            type: String,
        },
    },

    emits: {
        click: (e: MouseEvent) => true,
        dismiss: (e: MouseEvent) => true,
    },

    methods: {
        onClick(e: MouseEvent) {
            this.$emit('click', e);
        },

        onDismiss(e: MouseEvent) {
            this.$emit('dismiss', e);
        },
    },

    render() {
        return h('button', {
            class: [
                'dismissible-button',
                utility.flex,
                utility.round,
                utility.fs_reset,
                styles.button,
            ],
            type: 'button'
        }, [
            h('span', {
                class: styles.label,
                onClick: this.onClick,
            }, this.label),
            h('span', {
                class: styles.close,
                onClick: this.onDismiss,
                innerHTML: xclose,
            }),
        ]);
    },
});
